export default function (removeItemId) {
    // Display on product card that product has been added to cart
    const cartItems = $('#cart-preview-dropdown .side-cart-item');
    for (const cartItem of cartItems) {
        const $productIdElement = $(cartItem).find('[data-product-id]');

        // Defensive check: ensure element exists and has productId data
        if (!$productIdElement.length || !$productIdElement.data('productId')) {
            continue;
        }

        const itemId = $productIdElement.data('productId');
        const qtyElement = cartItem.querySelector('[value]');

        // Defensive check: ensure quantity element exists
        if (!qtyElement) {
            continue;
        }

        const itemQty = qtyElement.value;
        const itemTextContainer = $('.card').find(`[data-qtyInCart='${itemId}']`);
        // To add lang string
        itemTextContainer.html(`You have ${itemQty} in your cart`);
    }

    if (removeItemId) {
        $('.card').find(`[data-qtyInCart='${removeItemId}']`).html('');
    }
}
